export default __webpack_public_path__ + "static/media/SOF_logo.5cf38d30.png";